import LangProvider from 'providers/LangProvider';
import React from 'react';

// The language comes from the page (see gatsby-node.js); pages without one, like 404, are Icelandic
export const wrapPageElement = ({ element, props }) => (
  <LangProvider lang={props.pageContext.lang || 'is'}>{element}</LangProvider>
);
